import { render, staticRenderFns } from "./SaleHistoryEventSigned.vue?vue&type=template&id=3d674a23&scoped=true"
import script from "./SaleHistoryEventSigned.vue?vue&type=script&lang=ts"
export * from "./SaleHistoryEventSigned.vue?vue&type=script&lang=ts"
import style0 from "./SaleHistoryEventSigned.vue?vue&type=style&index=0&id=3d674a23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d674a23",
  null
  
)

export default component.exports